import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from 'src/app/shared/modals/confirmation-modal/confirmation-modal.component';
import { Observable } from 'rxjs';
import { UNSAVED_CHANGES_WARNING } from '@app/shared/constants';

@Injectable()
export class UnsavedChangesProxyService {
  constructor(private readonly bsModalService: BsModalService) {}

  public showModal(confirmCallback?: Function, rejectCallback?: Function): Observable<boolean> {
    const initialState = {
      title: 'Cancel?',
      text: UNSAVED_CHANGES_WARNING,
      confirmText: 'Yes',
      closeText: 'No',
      confirm: () => confirmCallback?.(),
      reject: () => rejectCallback?.()
    };

    const modal = this.bsModalService.show(ConfirmationModalComponent, {
      initialState,
      backdrop: 'static'
    });

    return modal.content.confirmation;
  }
}
